<div style="height:300px;">
  <div class="text-danger text-large p-mt-2 p-mb-4">
    <i class="text-xlarge fas fa-exclamation-circle p-mr-2"></i>We noticed that this employee has taken the following trainings in the past 6 months at a total cost of <strong>{{totalCost}}</strong>.
  </div>

  <div style="height: calc(100% - 70px)">
    <ag-grid-angular 
      style="width: 100%; height:100%;"
      class="ag-theme-alpine"
      [rowData]="employeeTrainingRecords"
      [columnDefs]="gridHeaders"
      [context]="context"
      [gridOptions]="gridOptions"
      [rowSelection]="{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>
</div>

<div class="modal-footer">
  <button pButton pRipple label="Close" class="p-button p-button-raised p-button-outlined" icon="pi pi-times" type="button" (click)="cancel();"></button>
</div>
